export const serviceFeatures = [
    {
        title: "eCommerce Website Development",
        description:
            "We deliver professional eCommerce website development services, creating custom online stores aligned with your brand goals. Our expert eCommerce developers integrate AI, cloud computing, and APIs to plan, scale, and optimize your store for performance, conversions, and sustainable growth.",
        icon: "/images/ecommerce-page-icons/ecom-web-development.png",
    },
    {
        title: "Ecommerce Application Development",
        description:
            "We offer eCommerce <a href='/mobile-app-development-services' class='text-black' target='_blank'>mobile app development services</a> for Android and iOS with features like push notifications and secure digital payments. Our custom-built mobile apps and marketplaces enhance customer experience, increase sales, and strengthen brand engagement through a smoother, faster online shopping journey.",
        icon: "/images/ecommerce-page-icons/ecom-app-development.png",
    },
    // {
    //     title: "B2B Ecommerce Development Services",
    //     description:
    //         "As a leading B2B eCommerce development agency, we build and optimize scalable ecosystems including web and mobile apps that connect vendors, customers, and businesses. Our expert developers deliver customized B2B solutions that drive growth and ensure seamless business operations.",
    //     icon: "/images/ecommerce-page-icons/b2b-ecommerce.avif",
    // },
    // {
    //     title: "B2C Ecommerce Development Services",
    //     description:
    //         "Explore the dynamic world of B2C eCommerce development with Bitsclan, where every click leads to a sale. Our expert developers design user-friendly interfaces, secure payment systems, and personalized shopping experiences that boost engagement, conversions, and long-term business growth.",
    //     icon: "/images/ecommerce-page-icons/b2c-ecommerce-development.png",
    // },
    {
        title: "Ecommerce UI/UX Design Services",
        description:
            "Bitsclan offers expert eCommerce UI/UX design services focused on intuitive layouts, responsive design, and engaging visuals. Our skilled designers build high-conversion, user-friendly online stores optimized for maximum ROI and seamless shopping experiences across all platforms.",
        icon: "/images/ecommerce-page-icons/uiux-ecommerce.png",
    },
    {
        title: "eCommerce Store & Platform Migration",
        description:
            "Upgrade your online store with our expert eCommerce platform migration services and totally get rid of outdated platforms that limit your growth. We move your products, customers, and orders securely, ensuring zero data loss, preserved design, and functionality for long-term business growth.",
        icon: "/images/ecommerce-page-icons/ecom-store-and-platform.png",
    },
    {
        title: "Cloud & Headless Commerce Development",
        description:
            "We deliver next-gen cloud and headless commerce development solutions using decoupled frontend-backend architecture. Our cloud-based eCommerce services enable fast performance, easy integrations, SEO-friendly structures, and flexibility to enhance digital shopping experiences across all devices and touchpoints.",
        icon: "/images/ecommerce-page-icons/cloud-headless.png",
    },
    // {
    //     title: "AI Chatbots & Virtual Assistants Development",
    //     description: `Bitsclan offers <a href='/ai-chatbot-development-services' class='text-black' target='_blank'>AI chatbot development services</a> and virtual assistant integration for eCommerce. Our virtual AI agents guide shoppers with personalized support, while machine learning algorithms detect fraud, prevent chargebacks, and keep eCommerce transactions safe and seamless.`,
    //     icon: "/images/ecommerce-page-icons/aichatbot-virtual-assistent.png",
    // },
];

export const roadmapContent = {
    shortHeading: "Guiding You From Platform Selection to a Successful Launch",
    heading: "Guiding You From <span>Platform Selection</span> to a Successful Launch",
    description:
        "Our consultative approach ensures your eCommerce success by aligning your business goals with the right tools & strategies, guiding you through every step from discovery to launch.",
    processData: [
        {
            title: "Initial discovery",
            description: "During our first discussion, we'll delve into your business goals, budget, and timeline. This stage helps us gauge whether you’ll need a dedicated software development team or one of our other engagement models (staff augmentation or end-to-end software outsourcing).",
            icon: "/images/roadmap-icons/platform-evaluation.svg",
        },
        {
            title: "Develop a strategy and build your team",
            description: "We’ll formulate a detailed strategy that outlines our approach to backend development, aligned with your specific needs and chosen engagement model. Get a team of top 1% specialists working for you.",
            icon: "/images/roadmap-icons/Design.svg",
        },
        {
            title: "Get started",
            description: "With the strategy in place and the team assembled, we'll commence work. As we navigate through the development phase, we commit to regularly updating you on the progress, keeping a close eye on vital metrics to ensure transparency and alignment with your goals.",
            icon: "/images/roadmap-icons/Discovery.svg",
        },
    ],
    cta: {
        text: "Book a Consultation", // Updated CTA to better reflect a consultative/strategy service
        link: "https://calendly.com/bitsclan-it/30min?" // Keeping the original link structure
    }
}

export const companyCta = {
    heading: "How Much Is Your Ecommerce Business Growth Worth to You?",
    // subHeading: "Learn how to handle spikes in traffic & drive sales without increasing headcount.",
    buttonText: "Start Your Ecommerce Project Today",
}

export const whyUsContent = {
    shortHeading: "Why Leading Brands Choose Bitsclan IT Solutions?",
    heading: "The Trusted Partner for Global Brands",
    // greenHeading: "We've Been ",
    // image: "/images/ecommerce-page-icons/why-section-ecommerce.avif",
    image: "/images/case-studies/lamise-beauty/industry.avif",
    content: "Bitsclan, a leading eCommerce web development agency, is chosen by top brands for its ecommerce expertise in integrating accounting, CRM, and ERP systems, and creating SEO-friendly designs that enhance search visibility and digital performance.",
    stats: [
        // {
        //     title: "Delivering Commerce Excellence Since",
        //     number: "2017"
        // },
        {
            title: "Expertise in Ecommerce Solutions",
            number: "2 Years"
        },
        {
            title: "Certified Platform Experts",
            number: "15+"
        },
        {
            title: "Years Strategic Digital Commerce Leadership",
            number: "9+"
        }
    ],
    imageStats: [
        {
            title: "ARR Achieved",
            number: "100M+"
        },
        {
            title: "",
            number: "",
        },
        {
            title: "Customer Success Rating",
            number: "4.9"
        }
    ],
    cta: null
}

export const ecommerceTableData = {
    sectionHeading: "Platform Comparison Pros & Cons",
    subHeading: "Compare Ecommerce Platforms Before You Choose",
    description: "Explore the strengths, limitations, & best-fit use cases of leading eCommerce platforms to make an informed decision for your business.",
    tableHead: ["Platform", "Pros", "Cons", "Best For"],
    tableData: [
        {
            textOne: "Shopify",
            textTwo: "Launch <strong>2–3x</strong> faster, <strong>99.9%</strong> uptime, <strong>8,000+</strong> apps available",
            textThree: "Limited backend flexibility (<strong>≈30%</strong> customization possible)",
            textFour: "D2C brands, SMEs",
        },
        {
            textOne: "WooCommerce",
            textTwo: "<strong>60%</strong> lower setup cost, <strong>100%</strong> open-source, <strong>50,000+</strong> plugins",
            textThree: "Hosting & security fully user-managed (adds <strong>~15%</strong> workload)",
            textFour: "SMEs, content-first",
        },
        {
            textOne: "Magento",
            textTwo: "Supports <strong>500K+</strong> SKUs, multi-store scalability, <strong>100+</strong> integrations",
            textThree: "Setup cost <strong>2–3x</strong> higher, longer deployment cycles",
            textFour: "Enterprises, global",
        },
        {
            textOne: "BigCommerce",
            textTwo: "Built-in B2B tools, <strong>99%</strong> uptime, SaaS maintenance-free",
            textThree: "Customization limited to <strong>~40%</strong> compared to headless setups",
            textFour: "B2B/B2C mid-large",
        },
        {
            textOne: "OpenCart",
            textTwo: "Up to <strong>70%</strong> lower cost, open-source, setup within days",
            textThree: "Lacks advanced enterprise automation (<strong>−50%</strong> scalability)",
            textFour: "Small retailers",
        },
        {
            textOne: "Salesforce CC",
            textTwo: "Native CRM sync, <strong>360°</strong> customer view, <strong>99.95%</strong> uptime",
            textThree: "High licensing cost (avg. <strong>$4K</strong>–<strong>$8K</strong>/month)",
            textFour: "Enterprise"
        },
        {
            textOne: "Headless",
            textTwo: "Loads <strong>3</strong>–<strong>5x</strong> faster, <strong>100%</strong> API-driven, omnichannel-ready",
            textThree: "Requires dev expertise (adds ~<strong>25</strong>–<strong>40%</strong> implementation time)",
            textFour: "Innovative brands"
        },
        {
            textOne: "Custom",
            textTwo: "<strong>100%</strong> control, tailor-fit architecture, scalable to any size",
            textThree: "Long dev cycles (<strong>6</strong>–<strong>12</strong> months), <strong>2</strong>–<strong>4x</strong> cost vs SaaS",
            textFour: "Specialized industries"
        }
    ]
    // tableHead: ["Platform", "Pros", "Cons", "Best For"],
    // tableData: [
    //     {
    //         textOne: "Shopify",
    //         textTwo: "Fast launch, secure, app marketplace",
    //         textThree: "Limited backend control",
    //         textFour: "D2C brands, SMEs",
    //     },
    //     {
    //         textOne: "WooCommerce",
    //         textTwo: "Open-source, cost-effective, WordPress CMS",
    //         textThree: "Hosting/security responsibility",
    //         textFour: "SMEs, content-first",
    //     },
    //     {
    //         textOne: "Magento",
    //         textTwo: "Enterprise features, multi-store, scalability",
    //         textThree: "Complex, higher cost",
    //         textFour: "Enterprises, global",
    //     },
    //     {
    //         textOne: "BigCommerce",
    //         textTwo: "Built-in B2B features, SaaS simplicity",
    //         textThree: "Less customizable than headless",
    //         textFour: "B2B/B2C mid-large",
    //     },
    //     {
    //         textOne: "OpenCart",
    //         textTwo: "Low cost, open-source, easy setup",
    //         textThree: "Fewer enterprise features",
    //         textFour: "Small retailers",
    //     },
    //     {
    //         textOne: "Salesforce CC",
    //         textTwo: "Deep CRM integration, enterprise tools",
    //         textThree: "High licensing cost",
    //         textFour: "Enterprise",
    //     },
    //     {
    //         textOne: "Headless",
    //         textTwo: "Future-proof, blazing fast, omnichannel",
    //         textThree: "Requires dev expertise",
    //         textFour: "Innovative brands",
    //     },
    //     {
    //         textOne: "Custom",
    //         textTwo: "Full control, unique workflows",
    //         textThree: "Long dev cycles, cost",
    //         textFour: "Specialized industries",
    //     },
    // ]
};

export const techStackData = {
    shortHeading: "Powering eCommerce Innovation",
    mainHeading: "Leading Brands Trust Bitsclan for <span>Digital Commerce Growth</span>",
    description: "We build scalable, high-performing eCommerce solutions using modern technologies to deliver seamless digital shopping experiences.",
    techStackIcons: [
        {
            image: "Frame.svg",
            width: 160,
            altText: "Shopify eCommerce Platform",
        },
        {
            image: "Frame-1.svg",
            width: 160,
            altText: "WooCommerce Online Store",
        },
        {
            image: "Frame-4.svg",
            width: 160,
            altText: " BigCommerce Store Builder",
        },
        {
            image: "Frame-6.svg",
            width: 110,
            altText: "Salesforce Commerce Cloud",
        },
        {
            image: "Frame-2.svg",
            width: 150,
            altText: "Magento eCommerce Platform",
        },
        // {
        //     image: "Group.svg",
        //     width: 160
        // },
        {
            image: "Frame-3.svg",
            width: 160,
            altText: "Adobe Commerce Solution",
        },

        {
            image: "Frame-5.svg",
            width: 160,
            altText: "OpenCart Online Store",
        },
        {
            image: "Frame-7.svg",
            width: 160,
            altText: "Next.js Web Framework",
        },
        {
            image: "Frame-8.svg",
            width: 160,
            altText: "Vue.js JavaScript Framework",
        },

    ]
}

export const ecommerceTechStacksData = {
    tabs: [
        "CMS & Headless",
        "Custom Technologies & Database",
        "Cloud Hosting & DevOps Tools",
        "Payments",
        "Integrations"
    ],

    tabItems: [
        { tab: "Custom Technologies & Database", icon: "/images/iconthree.png", name: "React JS" },
        { tab: "Custom Technologies & Database", icon: "/images/iconone.png", name: "Angular JS" },
        { tab: "Custom Technologies & Database", icon: "/images/icon4.png", name: "Vue JS" },
        { tab: "Custom Technologies & Database", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "Custom Technologies & Database", icon: "/images/database9.png", name: "Node Js" },
        { tab: "Custom Technologies & Database", icon: "/images/tech-stack-icons/laravel.svg", name: "Laravel" },
        { tab: "Custom Technologies & Database", icon: "/images/django-tech.svg", name: "Django" },
        { tab: "Custom Technologies & Database", icon: "/images/database6.png", name: "Python" },
        { tab: "Custom Technologies & Database", icon: "/images/tech-stack-icons/ruby_on_rails.svg", name: "Ruby On Rails" },
        { tab: "Custom Technologies & Database", icon: "/images/database1.png", name: ".Net" },
        { tab: "Custom Technologies & Database", icon: "/images/db5.png", name: "MySQL" },
        { tab: "Custom Technologies & Database", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "Custom Technologies & Database", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL" },
        { tab: "Custom Technologies & Database", icon: "/images/db1.png", name: "Firebase" },
        { tab: "Custom Technologies & Database", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/aws.svg", name: "AWS" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/google-cloud.svg", name: "Google Cloud" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/azure.svg", name: "Azure" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/digital-ocean.svg", name: "Digital Ocean" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/vercel.svg", name: "Vercel" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/netlify.png", name: "Netlify" },
        { tab: "Payments", icon: "/images/tech-stack-icons/stripe.webp", name: "Stripe" },
        { tab: "Payments", icon: "/images/tech-stack-icons/tocheckout.png", name: "To Checkout" },
        { tab: "Payments", icon: "/images/tech-stack-icons/braintree.webp", name: "Brain Tree" },
        { tab: "Payments", icon: "/images/tech-stack-icons/square.png", name: "Square" },
        { tab: "Payments", icon: "/images/tech-stack-icons/tamara.png", name: "Tammara" },
        { tab: "Payments", icon: "/images/tech-stack-icons/stripe.webp", name: "Stripe" },
        { tab: "Payments", icon: "/images/tech-stack-icons/paypal.png", name: "PayPal" },
        { tab: "Payments", icon: "/images/tech-stack-icons/square.png", name: "Square" },
        { tab: "Payments", icon: "/images/tech-stack-icons/klarna.png", name: "Klarna" },
        { tab: "Payments", icon: "/images/tech-stack-icons/apple-pay.png", name: "Apple Pay" },
        { tab: "Payments", icon: "/images/tech-stack-icons/google-pay.png", name: "Google Pay" },
        { tab: "Integrations", icon: "/images/tech-stack-icons/gohighlevel.png", name: "Go High Level" },
        { tab: "Integrations", icon: "/images/tech-stack-icons/clarity.jpg", name: "Clarity" },
        { tab: "Integrations", icon: "/images/tech-stack-icons/hubspot.webp", name: "HubSpot" },
        { tab: "Integrations", icon: "/images/tech-stack-icons/mailchamp.png", name: "Mail Champ" },
        { tab: "Integrations", icon: "/images/tech-stack-icons/tiktok.png", name: "Tiktok" },
        { tab: "CMS & Headless", icon: "/images/tech-stack-icons/shopify.png", name: "Shopify" },
        { tab: "CMS & Headless", icon: "/images/tech-stack-icons/woocommerce.png", name: "Woocommerce" },
        { tab: "CMS & Headless", icon: "/images/tech-stack-icons/contentfull.png", name: "Contentful" },
        { tab: "CMS & Headless", icon: "/images/tech-stack-icons/strapi.svg", name: "Strapi" },
        { tab: "CMS & Headless", icon: "/images/tech-stack-icons/sanity.svg", name: "Sanity" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/docker.svg", name: "Docker" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/kubernetes.svg", name: "Kubernetes" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/git-hub.svg", name: "GitHub Actions" },
        { tab: "Cloud Hosting & DevOps Tools", icon: "/images/tech-stack-icons/ci-cd.svg", name: "CI/CD pipelines" },
    ]
}

export const ecommercePageFaq = [
    {
        id: "collapseOne",
        question: "What are eCommerce web development services?",
        answer: "eCommerce web development services involve working with an eCommerce web development company to facilitate online store development. These services include a wide range of activities with the goal of building, maintaining, and optimizing digital storefronts.",
    },
    {
        id: "collapseTwo",
        question: "What is eCommerce Development Outsourcing?",
        answer: "eCommerce development outsourcing involves working with third-party eCommerce development companies to handle various aspects of the development process, such as creation, web design, backend development, frontend development, or mobile app development. Businesses may outsource entire projects or project components. They may also bring external developers onto their in-house teams if they need additional support.",
    },
    {
        id: "collapseThree",
        question: "Why do companies outsource eCommerce development?",
        answer: "Companies outsource eCommerce development for a variety of reasons, such as cost efficiency, access to niche expertise, scalability, and flexibility.:",
    },
    {
        id: "collapseFour",
        question: "What technologies are used in eCommerce software development?",
        answer: "eCommerce development involves a combination of languages and technologies. Examples include web development technologies for front-end development, such as HTML, CSS, JavaScript, React, Vue.js, or Angular, and back-end development, like PHP, Python, Ruby, or JavaScript with Node.js. It often requires databases such as MySQL, PostgreSQL, or MongoDB; cloud services like AWS, Azure, or Google Cloud; payment gateway integrations such as Stripe or Paypal; and more.",
    },
    {
        id: "collapseFive",
        question: "How long does it take to develop an eCommerce website?",
        answer: "The timeline for developing an eCommerce website varies depending on the complexity of the project, the features you want to incorporate, and the development approach. A simple eCommerce site might take weeks, while a more complex store could take months to a year or longer to build.",
    },
];

export const ecommercePageTestimonails = [
    {
        name: "Amanda Hawkins",
        enterprise: "Industrial E-Commerce",
        country: "Louisiana, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "Project Manager at JM Test Systems",
        profileImage: "/images/testimonials/amanda.avif",
        logoImage: "/images/testimonials/logo-jmtest.avif",
        text: "Working with Bitsclan completely modernized our operations. From real-time calibration tracking to automated rentals and reporting, the new e-commerce platform improved efficiency across every department. Their technical expertise and attention to detail made all the difference.",
        serviceTags: [
            { title: "Custom Development", link: "/custom-software-development-services" },
            { title: "ERP Integration", link: "/custom-software-development-services" },
            { title: "E-Commerce Automation", link: "/ecommerce-services" }
        ]
    },
    {
        name: "Ms. Chang Li",
        enterprise: "Fashion & Apparels (E-Commerce)",
        country: "Dubai, UAE",
        countryFlagImage: "/images/testimonials/flags/uae-flag.png",
        designation: "Head of Digital Strategy at Lamise Beauty",
        profileImage: "/images/testimonials/changli.avif",
        logoImage: "/images/testimonials/logo-lamise.png",
        text: "Bitsclan helped us bring the Lamise vision to life a seamless online store that feels elegant yet powerful. Our new Shopify Plus platform integrates with Odoo and marketing automation tools effortlessly, improving both sales and customer engagement.",
        serviceTags: [
            { title: "Shopify Plus", link: "/ecommerce-services" },
            { title: "Marketing Automation", link: "/custom-software-development-services" },
            { title: "Multi-Warehouse Integration", link: "/ecommerce-services" }
        ]
    },
    {
        name: "Johnny",
        enterprise: "Entertainment & Music Tech",
        country: "California, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "Founder & CEO at SongHeart",
        profileImage: "/images/testimonials/johnny.avif",
        logoImage: "/images/testimonials/logo-songheart.png",
        text: "Bitsclan took our concept for SongHeart and turned it into a beautiful, intuitive music gifting platform. Their ability to merge creativity with technology allowed us to scale quickly and deliver an unforgettable user experience for our customers.",
        serviceTags: [
            { title: "AI Personalization", link: "/ai-ml-development-services" },
            { title: "Web App Development", link: "/web-app-development-services" },
            { title: "User Experience Design", link: "/custom-software-development-services" }
        ]
    },
    {
        name: "Derek Miles",
        enterprise: "Retail & E-Commerce (Food & Lifestyle)",
        country: "Oregon, US",
        countryFlagImage: "/images/testimonials/flags/usa-flag.png",
        designation: "Operations Director at Abioto Baking",
        profileImage: "/images/testimonials/derek.avif",
        logoImage: "/images/testimonials/logo-abioto.png",
        text: "Bitsclan understood our passion for artisan baking and built a platform that truly reflects it. The new Abioto website combines warmth, functionality, and storytelling helping us reach a wider community of bakers while increasing online conversions.",
        serviceTags: [
            { title: "E-Commerce Design", link: "/ecommerce-services" },
            { title: "Brand Identity", link: "/custom-software-development-services" },
            { title: "Shopify Development", link: "/custom-software-development-services" }
        ]
    },
    // {
    //     name: "Sarah Coleman",
    //     enterprise: "Construction & Industrial Equipment",
    //     country: "Illinois, US",
    //     countryFlagImage: "/images/testimonials/flags/usa-flag.png",
    //     designation: "Training & Product Specialist at American Moisture Test",
    //     profileImage: "/images/testimonials/sarah.avif",
    //     logoImage: "/images/testimonials/logo-amt.png",
    //     text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
    //     serviceTags: ["Custom Web Development", "Equipment Management System", "ERP Integration"]
    // }
];

export const trendingInsights = {
    heading: "E-commerce Trends Insights & Strategies",
    description:
        "Learn the latest in DTC, headless commerce, and omnichannel retail. Get practical insights, expert opinions, and strategies to stay ahead in the competitive e-commerce landscape.",
};